import jQuery from 'jquery';
import $ from 'jquery'
import validate from 'jquery-validation'
import Slick from 'slick-carousel';
import '@fancyapps/fancybox';
import 'jquery-mask-plugin';

jQuery(document).ready(function(){
	jQuery('.listing_gallery').slick({
	  
	  dots: true,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  autoplay: true,
	  autoplaySpeed: 5000,
	  arrows: true,
	  responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: true,
			dots: true
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		}
	  ]
	});
});
jQuery(document).ready(function(){
	$("#phone_number").mask("000-000-0000", {placeholder: "___-___-____"});
	var str = jQuery(".single_pro_descs").text();
	if(str!=""){
		var res = str.split("line&para");
		console.log(res.length);

		var i=0;
		var p= '';
		for(i=0; i<res.length;i++){
			p +='<p>'+res[i]+'</p>';
		}
		jQuery(".single_pro_descs").html(p);
	}			
});